module.exports = __webpack_public_path__ + "media/images/riders/small/GEE_ATHERTON-5a1566156340a790cb69e7cc6582110a.png";